import { render, staticRenderFns } from "./followGoods.vue?vue&type=template&id=73548e34&"
import script from "./followGoods.vue?vue&type=script&lang=js&"
export * from "./followGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports